import {
  BottomSheetInformation,
  Query,
  VlocPaymentScheduleV2,
  VlocReviewDetailsV2,
  VlocReviewPageInput,
  VlocReviewPageResult,
  VlocReviewPageView,
} from '@varo/graphql-schema-types';
import GetVlocReviewPage from 'services/graphql/queries/GetVlocReviewPage';
import { AnyVariables, CombinedError, useQuery } from 'urql';

interface GetVlocReviewPageResult {
  result?: VlocReviewPageResult;
  autoPayBottomSheet?: BottomSheetInformation;
  payByCheckBottomSheet?: BottomSheetInformation;
  reviewDetails?: VlocReviewDetailsV2;
  paymentSchedule?: VlocPaymentScheduleV2[] | null;
  error?: CombinedError;
  fetching: boolean;
  refetch: () => void;
}

const useGetVlocReviewPage = ({
  input,
}: {
  input: VlocReviewPageInput;
}): GetVlocReviewPageResult => {
  const [response, refetch] = useQuery<Query, AnyVariables>({
    query: GetVlocReviewPage,
    requestPolicy: 'network-only',
    variables: { input },
  });

  const { data, fetching, error } = response;
  const vlocReviewPage = data?.vlocReviewPage as VlocReviewPageView;

  return {
    result: vlocReviewPage,
    autoPayBottomSheet: vlocReviewPage?.autoPayBottomSheet,
    payByCheckBottomSheet: vlocReviewPage?.payByCheckBottomSheet,
    reviewDetails: vlocReviewPage?.vlocReviewDetailsV2,
    paymentSchedule: vlocReviewPage?.vlocReviewDetailsV2?.paymentSchedule,
    error: error,
    fetching,
    refetch,
  };
};

export default useGetVlocReviewPage;
